import { render } from "./MonthlySplitTable.vue?vue&type=template&id=2576438a&scoped=true"
import script from "./MonthlySplitTable.vue?vue&type=script&lang=js"
export * from "./MonthlySplitTable.vue?vue&type=script&lang=js"

import "./MonthlySplitTable.vue?vue&type=style&index=0&id=2576438a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2576438a"]])

export default __exports__